module.exports = __webpack_public_path__ + "img/content-title.454ec942.png";